import { Failure } from '@mrhenry/failure';
import { html, TemplateResult } from 'lit';
import { live } from 'lit/directives/live.js';
import { staticText } from '../../../static-text';
import { Dispatcher } from '../../../types/booking-request';

export function confirmRequestInput(
	confirmRequest: boolean,
	dispatch: Dispatcher,
	assetUrl: string,
	confirmRequestFailure?: Failure
): TemplateResult {
	const changeHandler = ( e: InputEvent ) => {
		if ( e.target !== e.currentTarget ) {
			return;
		}

		if ( !( e.target instanceof HTMLInputElement ) ) {
			throw new Error( 'e.target should be instanceof HTMLInputElement' );
		}

		if ( !e.target.checked ) {
			dispatch( {
				type: 'UPDATE_CONFIRM_REQUEST',
				confirmRequest: e.target.checked,
				confirmRequestFailure: Failure.from( staticText.agreeToBookingProcedureFailureMessage ),
			} );

			return;
		}

		dispatch( {
			type: 'UPDATE_CONFIRM_REQUEST',
			confirmRequest: e.target.checked,
		} );
	};

	let failure = html``;
	if ( Failure.isFailure( confirmRequestFailure ) ) {
		failure = html`
			<div>
				<p class="form__field-validation-error theme-color-error">
					${confirmRequestFailure?.message}
				</p>
			</div>
		`;
	}

	return html`
		<div class="form__row">
			<div class="form__checkbox type-d">
				<input
					.checked=${live( confirmRequest )}
					@change=${changeHandler}
					class="form__checkbox__input"
					id="confirm-request"
					name="confirm-request"
					type="checkbox"
				/>

				<label
					class="form__checkbox__label"
					for="confirm-request"
				>
					${staticText.iAgreeToBookingProcedure}
				</label>
			</div>

			${failure}
		</div>
	`;
}
